import { createContext } from "react";
const IconContext = createContext();
export default IconContext;